module.exports = __webpack_public_path__ + "img/montaña__fondo.2ea2ed4e.svg";